export const getSchedulesByContractIdDefault = '{\n' +
    '    "contractId": "",\n' +
    '    "programName": "AP_PILLPACK"\n' +
    '}';

export interface IGetSchedulesByContractIdRequest {
    contractId: string
    programName: string
}
